/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import {View} from 'react-native';
import {MaterialCommunityIcons} from '@expo/vector-icons';
import CCText from '@/Atoms/CCText';
import CCButton from '@/Atoms/CCButton';
import Box from '@/Atoms/Box';
import Spacer from '@/Atoms/Spacer';
import CCColors from '@/Utils/CCColors';
import {vs} from '@/Utils/Dimensions';
import {getPaymentStatus} from './utils/paymentStatus';

interface PaymentStatusModalProps {
  status?: string;
  onClose: () => void;
  pendingOrder?: any;
  onRetry?: () => void;
  isProcessing?: boolean;
}

export default function PaymentStatusModal({
  status,
  onClose,
  pendingOrder,
  onRetry,
  isProcessing,
}: PaymentStatusModalProps) {
  const resolvedStatus = getPaymentStatus(status as any);
  const isSuccess = resolvedStatus === 'CHARGED';
  const isPending =
    (resolvedStatus !== 'CHARGED' && resolvedStatus !== 'FAILED') ||
    isProcessing;
  const isFailed = resolvedStatus === 'FAILED';

  return (
    <View
      style={{alignItems: 'center', justifyContent: 'center'}}
      data-testid="payment-status">
      <Spacer spacing={vs(20)} />
      <Box alignItems="center" justifyContent="center">
        <MaterialCommunityIcons
          name={
            isSuccess
              ? 'check-circle'
              : isPending
              ? 'clock-outline'
              : 'close-circle'
          }
          size={56}
          color={
            isSuccess
              ? CCColors.Green
              : isPending
              ? CCColors.Orange
              : CCColors.Red
          }
          data-testid={
            isSuccess
              ? 'success-icon'
              : isPending
              ? 'pending-icon'
              : 'failed-icon'
          }
        />
      </Box>
      <Spacer spacing={vs(30)} />
      <CCText
        fontSize={22}
        fontWeight="600"
        style={{textAlign: 'center', lineHeight: 30}}>
        {isSuccess
          ? 'Payment Successful!'
          : isPending
          ? 'Payment Processing'
          : 'Payment Failed'}
      </CCText>
      <Spacer spacing={vs(15)} />
      <CCText
        fontSize={16}
        color={CCColors.TextColor.LightGrey}
        style={{textAlign: 'center', lineHeight: 24}}>
        {isSuccess
          ? 'Your registration has been confirmed. Good luck with your tournament!'
          : isPending
          ? 'Please wait while we confirm your payment. Do not close this page.'
          : 'We could not process your payment at this moment. Please try again later or contact support if the issue persists.'}
      </CCText>
      <Spacer spacing={vs(40)} />
      <View
        style={{
          width: '100%',
          flexDirection: 'row',
          alignItems: 'center',
          gap: vs(10),
          justifyContent: 'center',
        }}>
        {isFailed && pendingOrder && onRetry && (
          <CCButton type="outline" onPress={onRetry} style={{flex: 1}}>
            <CCText color={CCColors.Primary.Default} fontWeight="600">
              Retry Payment
            </CCText>
          </CCButton>
        )}
        <CCButton type="fill" onPress={onClose} style={{flex: 1}}>
          {isSuccess ? 'Great!' : 'Close'}
        </CCButton>
      </View>
    </View>
  );
}
